// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function getPreviousState(state) {
  var ref = React.useRef(state);
  React.useEffect(function () {
        ref.current = state;
        
      });
  return ref.current;
}

function useInterval(callback, delay) {
  var savedCallback = React.useRef(callback);
  React.useEffect((function () {
          savedCallback.current = callback;
          
        }), [callback]);
  React.useEffect((function () {
          var tick = savedCallback.current;
          var id = setInterval(tick, delay);
          return (function (param) {
                    clearInterval(id);
                    
                  });
        }), [delay]);
  
}

export {
  getPreviousState ,
  useInterval ,
  
}
/* react Not a pure module */
